/** @ngInject */
export default function config($stateProvider) {
	$stateProvider
		.state('app.departments', {
			abstract: true,
			url: '/departments',
		})
		.state('app.departments.index', {
			url: '',
			component: 'departmentsIndexState',
		})
		.state('app.departments.index.new', {
			url: '/new',
			/** @ngInject */
			onEnter: function ($stateParams, $state, $document, $mdDialog) {
				$state.transition.promise.then(() => {
					$mdDialog
						.show({
							templateUrl: 'app/states/departments/departments-new.html',
							controller: 'DepartmentsNewStateController',
							controllerAs: 'vm',
							clickOutsideToClose: true,
							parent: angular.element($document.body),
							bindToController: true,
						})
						.finally(function () {
							$state.go('^')
						})
				})
			},
		})
		.state('app.departments.index.show', {
			url: '/:id',
			/** @ngInject */
			onEnter: function (
				$stateParams,
				$state,
				$document,
				$mdDialog,
				$log,
				department,
			) {
				$state.transition.promise.then(() => {
					$mdDialog
						.show({
							templateUrl: 'app/states/departments/departments-show.html',
							controller: 'DepartmentsShowStateController',
							controllerAs: 'vm',
							clickOutsideToClose: true,
							parent: angular.element($document.body),
							bindToController: true,
							locals: {
								department: department,
							},
						})
						.then(
							function () {
								$log.info('Closed normally.')
							},
							function () {
								$state.go('^')
							},
						)
				})
			},
			/** @ngInject */
			onExit: function ($mdDialog) {
				$mdDialog.hide()
			},
			resolve: {
				/** @ngInject */
				department: function ($stateParams, Department) {
					return Department.find($stateParams.id).then(function (department) {
						return Department.loadRelations(department, 'property')
					})
				},
			},
		})
		.state('app.departments.index.edit', {
			url: '/:id/edit',
			/** @ngInject */
			onEnter: function (
				$stateParams,
				$state,
				$document,
				$mdDialog,
				$log,
				department,
			) {
				$state.transition.promise.then(() => {
					$mdDialog
						.show({
							templateUrl: 'app/states/departments/departments-edit.html',
							controller: 'DepartmentsEditStateController',
							controllerAs: 'vm',
							clickOutsideToClose: true,
							parent: angular.element($document.body),
							bindToController: true,
							locals: {
								department: department,
							},
						})
						.then(
							function () {
								$log.info('Closed normally.')
							},
							function () {
								$state.go('^')
							},
						)
				})
			},
			/** @ngInject */
			onExit: function ($mdDialog) {
				$mdDialog.hide()
			},
			resolve: {
				/** @ngInject */
				department: function ($stateParams, Department) {
					return Department.find($stateParams.id, { bypassCache: true })
				},
			},
		})
		.state('app.departments.index.delete', {
			url: '/:id/delete',
			/** @ngInject */
			onEnter: function (
				$stateParams,
				$state,
				$mdDialog,
				$log,
				Department,
				department,
			) {
				$state.transition.promise.then(() => {
					$mdDialog
						.show(
							$mdDialog.confirm({
								title: 'Are you sure?',
								textContent:
									'Are you sure you want to delete ' + department.name + '?',
								ok: 'Delete',
								cancel: 'Cancel',
								theme: 'md-navbarTheme-theme',
							}),
						)
						.then(
							function () {
								department.DSDestroy().finally(function () {
									$state.go('^')
								})
							},
							function () {
								$state.go('^')
							},
						)
				})
			},
			resolve: {
				/** @ngInject */
				department: function ($stateParams, Department) {
					return Department.find($stateParams.id)
				},
			},
		})
}
